import { graphql } from "../../codegen/gql";

const countries = graphql(`
  query countries(
    $filterExpression: FilterExpression
    $page: Int
    $pageSize: Int
    $sortField: String
    $sortDirection: SortDirection
  ) {
    countries(
      filterExpression: $filterExpression
      page: $page
      pageSize: $pageSize
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      totalPages
      totalElements
      first
      last
      number
      size
      numberOfElements
      content {
        id
        name
        es
        it
        fr
        de
        pt
        region {
          id
          name
        }
      }
    }
  }
`);

export const CountryGQL = {
  query: { countries },
  mutation: {},
};
